angular
  .module('app')
  .controller('InvoiceController', InvoiceController);

InvoiceController.$inject = ['Session', 'Invoice'];

function InvoiceController(Session, Invoice) {
  var vm = this;
  vm.successfull = false;
  var invoices = Invoice.query({id: Session.id}).$promise;
  invoices.then(function (res) {
    vm.invoices = res;
  });

  vm.downloadInvoice = function (filmId, filmCat) {
    var invoice = Invoice.save({id: Session.id, film: filmId, category: filmCat}).$promise;
    invoice.then(function (res) {
      Session.open(res.url);
    });
  };
}
